import React from 'react';
import './NoResult.css';

export const NoResult = ({ noGamesFound }) => {
    return <div className="search-games__no-result-wrapper">
        <div className="game-search-no-result__icon" />
        <div className="no-result__text">
            {noGamesFound}
        </div>
    </div>;
};
